import type { Citation } from '../model/citation';

import type { Publication } from '@/services/getUserPublications';

/**
 * Maps a profile publication onto a citation. Only a record with a PubMed id
 * carries a PMID, so a DOI-only paper is never cited with one it does not have.
 */
export function publicationToCitation(publication: Publication): Citation {
  return {
    key: String(publication.id),
    title: publication.title,
    authors: publication.authors,
    journal: publication.journal,
    year: publication.year,
    pmid: publication.pubmedId,
    url: publication.url,
  };
}

/**
 * Narrows the list as the expert types. Every word must appear somewhere in
 * the title, journal, authors or year, so `kras 2023` finds the 2023 KRAS
 * paper. Keeps the server's newest-first order.
 */
export function filterPublications(publications: Publication[], query: string): Publication[] {
  const words = query.toLowerCase().split(/\s+/).filter(Boolean);

  if (words.length === 0) {
    return publications;
  }

  return publications.filter((publication) => {
    const haystack = [
      publication.title,
      publication.journal ?? '',
      publication.authors.join(' '),
      publication.year ? String(publication.year) : '',
    ]
      .join(' ')
      .toLowerCase();

    return words.every((word) => haystack.includes(word));
  });
}
